export interface IRankingBreakdown {
  id?: number;
  place?: number;
  points?: number;
  money?: number;
  rankingId?: number;
}

export const defaultValue: Readonly<IRankingBreakdown> = {};
